import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userOnboardByCreateLink } from "../../enterpriseApi";


const initialState = {
    IndividualConnection: {}
}

export const userOnboardByCreateLinkReducer = createAsyncThunk('/userOnboardByCreateLink', async (payload, thunkAPI) => {
    try {
        const response = await userOnboardByCreateLink(payload);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

const enterpriseSlice = createSlice({
    name: 'enterprise',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(userOnboardByCreateLinkReducer.fulfilled, (state, action) => {
            // console.log("getAllCardDetails ", JSON.stringify(action));
            state.IndividualConnection = action.payload;
        })
    }
});

export default enterpriseSlice.reducer;